import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import {getMessageRemindById, getMessageReviewById, setMessageReviewUserByMessageReviewId} from '@/api/message'
import {getFinanceInvoiceContent } from '@/api/financial-center'
@Component({
})
export default class BackMoneyParnterInfo extends Vue {
    logShow = true
    backMoneyInfo: any = ''
    financeBackMoneyDetailList = []
    status: number = null
    approval_id: number = null // 审批查看详情id
    approval_type: string = null //审批状态 type 0-审批，1-查看
    reviewStatus: string
    opinion = '' // 审批意见
    cancleReview = false
    reviewDialog = false
    fileList = []
    fileList1 = []
    turnParagraphArr = []
    moneyCertificatesArr = []
    addDataList: any

    editFileList = []
    editFiles = {
        account: null,
        isProof: null,
        remark: null,
        invoiceTypes: null,
        invoiceTitle: null,
        invoiceCode: null,
        invoiceBank: null,
        invoiceAccount: null,
        invoiceAddress: null,
        invoicePhone: null,
        // financeInvoiceDetailList: null,
    }
    isRequired = true
    editFileRequired = false
    types = ''
    approvalStatus = null
    isShow = null
    contentName = ''
    loading = false
    activities = []
    get orderAllPrice() {
        let num = 0
        if (this.backMoneyInfo.financeInvoiceDetailList) {
            this.backMoneyInfo.financeInvoiceDetailList.map(item => num += Number(item.price))
        }
        return num
    }
    created() {
        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)
    }

    formatDate = formatDate

    getFinanceInvoiceContent(val) {
        if (val) {
            getFinanceInvoiceContent({
                companyName: val
            }).then((res: any) => {
                res.financeInvoiceContent.forEach((item) => {
                    if (item.types == this.backMoneyInfo.content) {
                        this.contentName = item.content
                    }
                })
            })
        }
    }

    async getMsgData(id) {
        this.loading = true
        await getMessageRemindById({id: id}).then((data: any)=>{

        this.backMoneyInfo = data.result.messageRemindInfo
        this.isShow = this.backMoneyInfo.isShow
        this.approvalStatus = this.backMoneyInfo.status
        let allThisAmount = 0
        this.backMoneyInfo.financeInvoiceDetailList.forEach((item) => {
            allThisAmount += Number(item.price)
        })
        // 已通过的和审批中的按返回的结果展示（其他都减去本次开票金额）
        this.backMoneyInfo.surplusInvoicePrice = (this.isShow == '1' && this.approvalStatus == '1') || (this.isShow == '0' && this.approvalStatus == '0') ? this.backMoneyInfo.surplusInvoicePrice : this.backMoneyInfo.surplusInvoicePrice - allThisAmount

        this.editFileList = data.result.editFileList
        this.editFiles.account = this.backMoneyInfo.account
        this.editFiles.isProof = this.backMoneyInfo.isProof
        this.editFiles.remark = this.backMoneyInfo.remark
        this.editFiles.invoiceTypes = this.backMoneyInfo.types === '增值税专用发票' ? '0' : '1'
        this.editFiles.invoiceTitle = this.backMoneyInfo.title
        this.editFiles.invoiceCode = this.backMoneyInfo.invocieCode
        this.editFiles.invoiceBank = this.backMoneyInfo.bank
        this.editFiles.invoiceAccount = this.backMoneyInfo.invoiceAccount
        this.editFiles.invoiceAddress = this.backMoneyInfo.address
        this.editFiles.invoicePhone = this.backMoneyInfo.phone
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.approval_type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.getFinanceInvoiceContent(this.backMoneyInfo.account)
        this.activities = data.result.messageRemindInfo.messageReviewList
        this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }

    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.reviewStatus !== '0' || this.approval_type !== '0') return false
        return this.editFileList.some(item => item.file === key)
    }
    async getMessageReviewById() {
        const data: any = await getMessageReviewById(this.approval_id,this.types)
        this.backMoneyInfo = data.result
        this.editFileList = data.result.editFileList
        this.editFiles.account = this.backMoneyInfo.account
        this.editFiles.isProof = this.backMoneyInfo.isProof
        this.editFiles.remark = this.backMoneyInfo.remark
        this.editFiles.invoiceTypes = this.backMoneyInfo.types === '增值税专用发票' ? '0' : '1'
        this.editFiles.invoiceTitle = this.backMoneyInfo.title
        this.editFiles.invoiceCode = this.backMoneyInfo.invocieCode
        this.editFiles.invoiceBank = this.backMoneyInfo.bank
        this.editFiles.invoiceAccount = this.backMoneyInfo.invoiceAccount
        this.editFiles.invoiceAddress = this.backMoneyInfo.address
        this.editFiles.invoicePhone = this.backMoneyInfo.phone
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.approval_type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
    }
    getSummaries(param: any) {
        const { columns, data } = param;
        const sums: any = [];
        columns.forEach((column: any, index: number) => {
            if (index === 0) {
                sums[index] = '总计';
                // return;
            } else if (index === 7) {
                const values = data.map((item: any) => Number(item[column.property]));
                if (!values.every((value: any) => isNaN(value))) {
                    sums[index] = values.reduce((prev: any, curr: any) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0)
                } else {
                    sums[index] = '0'
                }
            } else {
                sums[index] = '';
            }
        });
        return sums;
    }
    // 通过
    // 1通过 2驳回
    openReviewDialog(status: number) {
        this.status = status
        this.reviewDialog = true
    }
    // 关闭审批弹窗
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }
    reviewDialogConfirm() {
        const newObj = this.editFiles
        for(const key in newObj) {
            if(!this.editFileList.some(item => item.file === key)) delete newObj[key]
        }
        if(this.isRequired) {
            for(const key in newObj) {
                if(!newObj[key] || newObj[key].length === 0) {
                    this.editFileRequired = true
                    break;
                } else {
                    this.editFileRequired = false
                }
            }
        }
        if(this.editFileRequired) {
            this.$message.error('请将编辑信息填写完整')
            return
        }
        const obj = {
            messageReviewId: this.approval_id,
            status: this.status,
            opinion: this.opinion,
            form: this.status === 1 ? newObj : {}
        }
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
            setTimeout(() => {
                window.close()
            }, 1500)
        })
    }
}
